module.exports = __webpack_public_path__ + "img/job.44b9462a.png";